import type { JSX } from 'react';
import { Link, type LinkProps } from 'wouter';

import { useScrollToTop } from '@hooks/useScrollToTop';

type NavLinkProps = {
  onClick?: () => void;
  doNotScrollToTop?: boolean;
} & LinkProps;

export const NavLink = ({ onClick, doNotScrollToTop, ...rest }: NavLinkProps): JSX.Element => {
  const scrollToTop = useScrollToTop();

  const handleLinkClick = (): void => {
    if (onClick) {
      onClick();
    }
    if (!doNotScrollToTop) {
      scrollToTop();
    }
  };

  return <Link onClick={() => handleLinkClick()} {...rest} />;
};
